import { StatusText } from '../../../../components/ui'
import type { OrderMessageTone } from './types'

interface OrderStatusMessageProps {
  message: string | null
  tone: OrderMessageTone
}

export function OrderStatusMessage({ message, tone }: OrderStatusMessageProps) {
  if (!message) {
    return null
  }

  return (
    <StatusText className="mt-3" tone={tone === 'danger' ? 'danger' : 'success'} aria-live="polite">
      {message}
    </StatusText>
  )
}
